import { Component, Inject, OnInit } from '@angular/core';
import { Validators, UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrComponent } from '../util/toastr/toastr.component';
import { Misc } from '../util/misc';
import { FaturamentoService } from 'src/app/services/faturamento.service';
import { CalculoService } from 'src/app/services/calculo.service';
import { Faturamento } from 'src/app/models/faturamento.model';


@Component({
  selector: 'app-faturamento-form',
  templateUrl: './faturamento-form.component.html',
  styleUrls: ['./faturamento-form.component.scss']
})

export class FaturamentoFormComponent implements OnInit {

  basicForm: UntypedFormGroup;
  isDisabled = true;
  totalReceitaBruta = 0;

  constructor(
    protected faturamentoService: FaturamentoService,
    protected calculoService: CalculoService,
    public dialogRef: MatDialogRef<Faturamento>,
    private fb: UntypedFormBuilder,
    private toastr: ToastrComponent,
    public misc: Misc,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.createForm();
  }

  createForm() {
    this.basicForm = this.fb.group({
      id: [0],
      evento: [null, [Validators.required]],
      percentual: [null, [Validators.required, Validators.min(1), Validators.max(100)]],
      valor: { value: 0, disabled: false }
    });
  }

  close(): void {
    this.dialogRef.close();

  }

  calcularValor() {
    if (this.basicForm.value.percentual <= 0) {
      alert('Percentual não pode ser igual ou menor que 0');
    }
    const evento: Faturamento = this.basicForm.value;
    const valor = (evento.percentual * this.totalReceitaBruta / 100).toFixed(2);
    this.basicForm.patchValue({ valor });
  }

  calcularPercentual() {
    const evento: Faturamento = this.basicForm.value;
    const valorPer = Number(evento.valor);
    var percentual = Number(((valorPer / this.totalReceitaBruta) * 100).toFixed(2));
    if (percentual.toString() === 'NaN') {
      percentual = 0;
    }
    this.basicForm.patchValue({ percentual });
  }

  save() {
    const evento: Faturamento = this.basicForm.getRawValue();

    const totalPercentual = Number(this.data.totalPercentual) + Number(evento.percentual);

    if (totalPercentual > 100.09) {
      this.toastr.mostrarMensagem('aviso', 'Atenção', `Porcentagem excedida: ${totalPercentual}%`);
      return;
    }

    evento.estimativaId = this.data.estimativaId;
    this.faturamentoService.create(evento).subscribe(() => {
      this.close();
      this.toastr.mostrarMensagem('sucesso', 'Sucesso', 'Registro salvo com sucesso');
    }, err => {
      this.toastr.mostrarMensagem('erro', 'Erro', 'Erro ao salvar o registro');
    });
  }

  ngOnInit() {
    this.calculoService.calcularReceitaBrutaAdotado(this.data.estimativaId)
      .subscribe(result => {
        this.totalReceitaBruta = result;
      });
  }
}
